import { useMemo } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { Formik } from "formik";
import { StyledModalTitle } from "../../@ui/StyledModalTitle";
import { useBoundarySelectContext } from "./BoundarySelectContext";
import { BufferUnit } from "../../constant/BufferUnit";
import ThemedModal from "../../@ui/Modal/ThemedModal";

const BoundarySettingsModal = () => {
  const { boundaries, configBoundaryId, setConfigBoundaryId, bufferBoundary } =
    useBoundarySelectContext();
  const initialValues = useMemo(() => {
    const boundary = boundaries.find((b) => b.boundaryId === configBoundaryId);
    return {
      name: boundary?.name ?? "",
      bufferDistance: boundary?.bufferDistance ?? 0,
      bufferUnit: boundary?.bufferUnit ?? BufferUnit.metres,
    };
  }, [configBoundaryId]);

  const onSubmit = (values: any) => {
    bufferBoundary(configBoundaryId!, values.bufferDistance, values.bufferUnit);
    setConfigBoundaryId(undefined);
  };

  const cancel = () => {
    setConfigBoundaryId(undefined);
  };

  return (
    <ThemedModal
      centered
      show={!!configBoundaryId}
      onHide={cancel}
      backdrop="static"
    >
      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        {({ values, handleChange, submitForm }) => (
          <Form>
            <Modal.Header className="bg-secondary text-white" closeButton>
              <StyledModalTitle>{values.name}</StyledModalTitle>
            </Modal.Header>
            <Modal.Body>
              <Form.Label htmlFor="bufferDistance">Buffer Area</Form.Label>
              <InputGroup>
                <Form.Control
                  id="bufferDistance"
                  name="bufferDistance"
                  type="number"
                  value={values.bufferDistance}
                  onChange={handleChange}
                />
                <Form.Select
                  id="bufferUnit"
                  name="bufferUnit"
                  value={values.bufferUnit}
                  onChange={handleChange}
                >
                  <option value={BufferUnit.metres}>Metres</option>
                  <option value={BufferUnit.feet}>Feet</option>
                  <option value={BufferUnit.kilometres}>Kilometres</option>
                  <option value={BufferUnit.miles}>Miles</option>
                </Form.Select>
              </InputGroup>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={() => submitForm()}>
                Ok
              </Button>
              <Button variant="danger" onClick={cancel}>
                Cancel
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </ThemedModal>
  );
};

export default BoundarySettingsModal;
